import React from "react";
import "./educationSystem.scss";

//Imagens:
import ImgEducationSystem from "../../../../assets/education/education.png";
import { useTranslation } from "react-i18next";

function EducationSystem() {

  const { t } = useTranslation()

  return (
    <div className="container-education-system">
      <div className="img-education-system">
        <img src={ImgEducationSystem} alt="" />
      </div>
      <div className="texts-education-system">
        <h1>{t("education.title")}</h1>
        <p>{t("education.section_text_1")}</p>
        <p>{t("education.section_text_2")}</p>
        <a href="/form">
          <button id="btn-education-system">{t("buttons.demo_btn_alternative_text_1")}</button>
        </a>
      </div>
    </div>
  );
}

export default EducationSystem;
